import React from 'react';
import {connect} from 'react-redux';

import BenchlingConfig from 'BenchlingConfig';
import ExportDropdown from 'nav/expanded/folder-toolbar/ExportDropdown';
import {BenchlingDispatch} from 'redux-stores/Store';
import BulkUpdateRequestsButton from 'requests/dashboard/BulkUpdateRequestsButton';
import * as InputReduxActions from 'requests/inputs/InputReduxActions';
import {Request} from 'requests/RequestConstants';
import RequestStatusDropdown from 'requests/RequestStatusDropdown';
import {ButtonStyle} from 'ui-library/buttons/Button';
import {initiateTextDownload} from 'util/TextToBlobUtil';

import {requestsToCSV} from './requestsToCSV';

interface Props {
  selectedRequests: Array<Request>;
}

interface DispatchProps {
  onBulkUpdateRequests: Function; // TODO(TypeScript): Define more specific function type
}

function mapDispatchToProps(dispatch: BenchlingDispatch): DispatchProps {
  return {
    onBulkUpdateRequests: (requestIds: Array<string>, data: object) => {
      dispatch(InputReduxActions.bulkUpdateRequests(requestIds, data));
    },
  };
}

class RequestsToolbar extends React.Component<Props & DispatchProps> {
  _handleExportToCSV(): void {
    initiateTextDownload(requestsToCSV(this.props.selectedRequests), 'requests.csv');
  }

  render(): JSX.Element | null {
    if (this.props.selectedRequests.length === 0) {
      return null;
    }

    return (
      <div className="buttonGroup">
        <BulkUpdateRequestsButton
          buttonStyle={ButtonStyle.TERTIARY_WHITE}
          requests={this.props.selectedRequests}
        />
        {BenchlingConfig.ENABLE_EXPORTS && (
          <ExportDropdown
            menuItems={[
              [
                {
                  name: 'Export Selected Rows to CSV',
                  handleOnClick: () => {
                    this._handleExportToCSV();
                  },
                },
              ],
            ]}
            useCaret={true}
          />
        )}
        <RequestStatusDropdown
          isDisabled={false}
          buttonStyle={ButtonStyle.TERTIARY_WHITE}
          onUpdateRequestStatus={(newStatus: string) =>
            this.props.onBulkUpdateRequests(
              this.props.selectedRequests.map(({id}) => id),
              {
                requestStatus: newStatus,
              }
            )
          }
        />
      </div>
    );
  }
}

export default connect(null, mapDispatchToProps)(RequestsToolbar);
